@let configValue = config();
@let labels = configValue?.labels;
@let options = configValue?.options;
@if (options) {
  <div [matTooltip]="control()?.disabled ? (disabledTooltipText() || config()?.labels?.disabledTooltip) : undefined" matTooltipPosition="above">
    @switch (options.formFieldType) {
      @case (FormFieldType.text) {
        <app-text-form-field [name]="name()" [path]="pathStr()" [labels]="labels" [options]="options" [errorStateMatcher]="errorStateMatcher()"></app-text-form-field>
      }
      @case (FormFieldType.select) {
        <app-select-form-field [name]="name()" [labels]="labels" [options]="options" [errorStateMatcher]="errorStateMatcher()"></app-select-form-field>
      }
      @case (FormFieldType.checkbox) {
        <app-checkbox-form-field [name]="name()" [labels]="labels" [options]="options"></app-checkbox-form-field>
      }
      @case (FormFieldType.autocomplete) {
        <app-autocomplete-form-field [name]="name()" [labels]="labels" [options]="options" [errorStateMatcher]="errorStateMatcher()"></app-autocomplete-form-field>
      }
      @case (FormFieldType.datePicker) {
        <app-date-picker-form-field [name]="name()" [labels]="labels" [options]="options" [errorStateMatcher]="errorStateMatcher()"></app-date-picker-form-field>
      }
      @case (FormFieldType.keyUsages) {
        <app-key-usage-form-field [name]="name()" [options]="options"></app-key-usage-form-field>
      }
      @case (FormFieldType.extendedKeyUsages) {
        <app-extended-key-usage-form-field [name]="name()" [options]="options"></app-extended-key-usage-form-field>
      }
    }
  </div>
}
